/**
 * @file src/store/highPriorityIssueStore.ts
 * @fileoverview Zustand store for high-priority issue alerts.
 */
import { create } from 'zustand';
import type { GithubRoadmapIssue } from '../utils/githubRoadmap';

interface HighPriorityIssueState {
  issues: GithubRoadmapIssue[];
  isOpen: boolean;
  setIssues: (issues: GithubRoadmapIssue[]) => void;
  open: () => void;
  close: () => void;
}

export const useHighPriorityIssueStore = create<HighPriorityIssueState>(set => ({
  issues: [],
  isOpen: false,
  setIssues: issues => set({ issues }),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false })
}));
